import { graphql, useStaticQuery } from "gatsby"

const useSocialNetworks = () => {
  try {
    const data = useStaticQuery(graphql`
      query GlobalSocialNetworksQuery {
        networks: allGlobals(filter: { handle: { eq: "social_networks" } }) {
          nodes {
            networks {
              networkUrl
              networkType {
                value
                label
                key
              }
            }
          }
        }
      }
    `)

    return data.networks.nodes[0].networks || []
  } catch {
    return []
  }
}

export default useSocialNetworks
